module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S5 Black.0afeb13e.png";